import { useSettings } from '@loadsmart/react-frontend-settings'

import { useSettingsSettled } from 'core/ui/hooks/useSettingsSettled'

export const AI_CHAT_FLAG = 'flags.ENABLE_AI_CHAT'

export function useAssistantFlag() {
  const settingsSettled = useSettingsSettled()
  const { isLoading, values } = useSettings([AI_CHAT_FLAG])
  const isFlagLoading = !settingsSettled || isLoading

  return {
    isLoading: isFlagLoading,
    isEnabled: !isFlagLoading && Boolean(values?.[0]),
  }
}
